import React from 'react';
import { PictoProps } from './index';

export const User = (props: PictoProps) => (
  <svg
    width={props.width || '19'}
    height={props.height || '20'}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4443 19V17C17.4443 14.7909 15.6535 13 13.4443 13H5.44434C3.2352 13 1.44434 14.7909 1.44434 17V19"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="9.44434"
      cy="5"
      r="4"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
